<template>
  <div class="card border-0">
    <div class="card-body px-4 py-3">
      <template v-for="(score, index) in sortedAggregateScores">
        <div v-if="score['number_of_reviews'] > 0" :key="index" class="row py-3">
          <div class="col-4 pr-0">
            <img :src="companies[index + 1].logo" class="logo" :alt="`${companies[index + 1].name} logo`" />
            <span class="average ml-2 ml-sm-4">{{ score.rating.toFixed(1) }}</span>
          </div>
          <div class="col-8 pl-0 pr-2 pr-sm-3 pt-03">
            <mobialis-star-bar
              :stacked="false"
              :spacing="!isAVRMobile ? 1 : 0"
              :reviewCount="score.number_of_reviews"
              :aggregateRating="score.rating"
              :reviewCountLabel="`${$t('message.DHS.reviews.reviewCount')}`"
            ></mobialis-star-bar>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
const av = require('../../assets/av-icon-black.svg');
const google = require('../../assets/Google.svg');
const facebook = require('../../assets/Facebook.svg');

export default {
  name: 'BreakdownCard',
  components: {},
  data() {
    return {
      companies: {
        1: { logo: google, name: 'Google' },
        2: { logo: facebook, name: 'Facebook' },
        3: { logo: av, name: 'AutoVerify' },
      },
    };
  },
  props: {
    scores: {
      type: Array,
      required: true,
    },
  },
  computed: {
    sortedAggregateScores() {
      const sorted = [...this.scores];
      return sorted.sort((a, b) => a.outlet - b.outlet);
    },
  },
};
</script>

<style scoped lang="scss">
img.logo {
  width: 24px;
  display: inline-block;
}
.average {
  display: inline-block;
  font-size: 20px;
  line-height: 24px;
  font-weight: bold;
  top: 3px;
  position: relative;
}
.pt-03 {
  padding-top: 3px;
}
@media (min-width: 576px) {
  .card-body {
    min-height: 220px;
  }
}
</style>
